import { makeStyles } from "@mui/styles";
import { colors, Commons } from "styleguide";

const styles = makeStyles({
  bannerContainer: {
    ...Commons.coverBackground,
    width: "100%",
    position: "relative",
    borderRadius: 50,
    overflow: "hidden",
    animation: "$neonBgLoop 3s linear infinite",
    gap: 30,
    padding: "50vh 18px 30px 18px",
    backgroundColor: colors.black,
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
    margin: "-20vh 0 60px 0",
    zIndex: 1,
    [Commons.midQuery]: {
      borderRadius: 24,
      flexDirection: "column",
      padding: "50vh 12px 12px 12px",
    },
  },
  blurBanner: {
    position: "absolute",
    zIndex: 0,
    width: "100%",
    height: "100%",
    backgroundColor: colors.secondary,
    opacity: 0.75,
    left: 0,
    top: 0,
  },
  title: {
    position: "relative",
    color: colors.white,
    fontSize: 48,
    textAlign: "left",
    margin: "0 0 12px 0",
    [Commons.smallQuery]: {
      fontSize: 30,
    },
  },
  containerProfileImage: {
    ...Commons.flexRow,
    position: "relative",
    backgroundColor: colors.orange,
    margin: 0,
    width: "fit-content",
    gap: 12,
    padding: "6px 12px",
    borderRadius: 30,
    [Commons.smallQuery]: {
      gap: 6,
    },
  },
  profileImage: {
    width: 48,
    height: 48,
    borderRadius: "50%",
    backgroundColor: colors.white,
    objectFit: "cover",
    [Commons.smallQuery]: {
      width: 32,
      height: 32,
    },
  },
  nameProfile: {
    position: "relative",
    color: colors.black,
    fontSize: 24,
    textAlign: "center",
    margin: 0,
    fontWeight: 700,
    "& span": {
      fontWeight: 400,
      fontSize: 18,
    },
    [Commons.smallQuery]: {
      fontSize: 18,
      "& span": {
        fontSize: 12,
      },
    },
  },
  parsedContent: {
    color: colors.white,
    textAlign: "left",
    position: "relative",
    "& h2, & h3": {
      fontWeight: 700,
      fontSize: 30,
    },
    "& p": {
      fontWeight: 400,
      fontSize: 18,
    },
    "& a": {
      color: colors.primary,
    },
  },
  "@keyframes neonBgLoop": {
    "0%": {
      boxShadow: `0 0 50px 3px ${colors.orange}30`,
    },
    "50%": {
      boxShadow: `0 0 50px 3px ${colors.orange}`,
    },
    "100%": {
      boxShadow: `0 0 50px 3px ${colors.orange}30`,
    },
  },
});

export default styles;
